export default {
	/**
	 * Set all fields
	 * @param {Array} allFields 
	 */
	setAllFields(state, allFields) {
		state.all = allFields
	},
}
